import * as React from 'react';
import NextLink, { LinkProps } from 'next/link';
import classNames from 'classnames';
import * as Styled from './icon-link.styled';

export interface Props extends LinkProps {
  /**
   * Custom class name to be applied to the anchor element.
   */
  className?: string;

  /**
   * Indicates if the icon link is disabled.
   *
   * @default false
   */
  disabled?: boolean;

  /**
   * Custom label to be displayed with the icon.
   */
  label?: React.ReactNode;

  /**
   * Custom styles to be applied to the anchor element.
   */
  style?: React.CSSProperties;

  /**
   * Target property for the anchor element.
   *
   * @default '_self'
   */
  target?: '_blank' | '_parent' | '_self' | '_top';
}

const IconLink: React.FunctionComponent<Props> = ({
  children,
  className,
  disabled = false,
  label,
  style,
  target = '_self',
  ...props
}) => {
  const linkProps = props;

  if (disabled) {
    linkProps.href = '';
  }

  const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!disabled) {
      return;
    }
    return event.preventDefault();
  };

  return (
    <NextLink {...linkProps} passHref>
      <Styled.Anchor
        className={classNames(className, { disabled })}
        onClick={onClick}
        style={style}
        target={target}
      >
        {children}
        {label && <Styled.Label>{label}</Styled.Label>}
      </Styled.Anchor>
    </NextLink>
  );
};

IconLink.displayName = 'IconLink';

export default IconLink;
